import styled from 'styled-components'

export interface ISelectItemsContainerProps {
  maxHeight?: string
}

export const SelectedItemsContainer = styled.div<ISelectItemsContainerProps>`
  max-height: ${({ maxHeight }) => maxHeight};
  overflow-y: scroll;
  gap: 6px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`
